import React, { useEffect, useState } from "react";
import SearchBar from "../../components/UI/SearchBar";
import Loader from "../../components/Loader/Loader";
import CardDropDownList from "../../components/Card/CardDropDownlList";
import Carousel from "../../components/Carousel/Carousel2";
import HttpService from "../../HttpService";
import { useCustomStyles, useCreateTheme, useColumns } from "./customHooks";
import DataTable from "react-data-table-component";

const Packages = (props) => {
  const customStyles = useCustomStyles();
  useCreateTheme();

  const [packages, setPackages] = useState([]);

  const [companies, setCompanies] = useState([]);
  const [banners, setBanner] = useState([]);
  const [bannerLoading, setBannerLoading] = useState(false);
  const [loadingPackages, setPackageLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let companyList = [];
    const fetchProducts = async () => {
      setError(false);
      setPackageLoading(true);
      setBannerLoading(true);
      let url = "/packages";
      try {
        const packages = await HttpService.get(url);
        const banner = await HttpService.get("/banners");
        setPackages(packages.data.packages);

        for (const packagee in packages.data.packages) {
          companyList.push({
            name: packages.data.packages[packagee].company_name.name,
            value: packages.data.packages[packagee].company_name.name,
          });
        }
        setCompanies(companyList);
        setBanner(banner.data.banners[0] && banner.data.banners[0]);
        // setProductCount(products.data.productCount);
      } catch (error) {
        setError(true);
      }
      setPackageLoading(false);
      setBannerLoading(false);
    };

    fetchProducts();
  }, []);

  const searchProductByCategory = async (network) => {
    let packages = null;

    setPackageLoading(true);

    try {
      if (network) {
        packages = await HttpService.get(`/packages/${network.name}`);
      } else {
        packages = await HttpService.get("/packages");
      }

      setPackages(packages.data.packages);
    } catch (e) {
      setError(e);
    }
    setPackageLoading(false);
  };

  const addToCompare = (packages) => {
    props.history.push({
      pathname: "/comparePackages",

      state: { packages: packages },
    });
  };
  const columns = useColumns(addToCompare);

  return (
    <React.Fragment>
      <section className="magazine-top" style={{ backgroundColor: "#fff" }}>
        {bannerLoading ? (
          <Loader />
        ) : (
          <Carousel
            image={banners && banners.image}
            heading={banners && banners.heading}
          />
        )}
      </section>

      <section
        id="product-amazon"
        className="product-shop-page product-shop-full-grid"
        style={{ backgroundColor: "#fff" }}
      >
        <div className="container">
          <div className="row">
            <div className="order-sm-2 order-md-1  col-12 col-md-4 col-lg-3 ">
              <SearchBar />
              <CardDropDownList
                items={companies}
                title="Networks"
                default="All"
                clickHandler={searchProductByCategory}
              />
            </div>
            <div className=" order-sm-4 order-md-4   col-10 col-md-9 col-lg-9 product-grid">
              <div className="row">
                <div className="tab-content col-12">
                  <div
                    // className="tab-pane fade "
                    id="home"
                    // role="tabpanel"
                    aria-labelledby="home-tab"
                  ></div>
                  {loadingPackages ? (
                    <Loader />
                  ) : (
                    <DataTable
                      columns={columns}
                      data={packages && packages}
                      pagination
                      theme="solarized"
                      title={`Showing ${packages.length} packages`}
                      customStyles={{ ...customStyles, width: "100%" }}
                      // add for checkbox selection
                      //   onSelectedRowsChange={onSelectRowChange}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Packages;
